import api from './api';
import { BarberCreationRequest, BarberCreationResponse } from '../types/barber.types';

export const adminService = {
    // Create new barber (admin only)
    createBarber: async (data: BarberCreationRequest): Promise<BarberCreationResponse> => {
        const response = await api.post<BarberCreationResponse>('/admin/barbers', data);
        return response.data;
    },
};
